"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftSaleConfigToJSON = exports.NftSaleConfigFromJSONTyped = exports.NftSaleConfigFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function NftSaleConfigFromJSON(json) {
    return NftSaleConfigFromJSONTyped(json, false);
}
exports.NftSaleConfigFromJSON = NftSaleConfigFromJSON;
function NftSaleConfigFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'name': json['name'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'icon': !(0, runtime_1.exists)(json, 'icon') ? undefined : json['icon'],
        'image': !(0, runtime_1.exists)(json, 'image') ? undefined : json['image'],
        'lineItems': (json['lineItems'].map(_1.NftSaleConfigLineItemFromJSON)),
        'minQuantity': json['minQuantity'],
        'maxQuantity': json['maxQuantity'],
        'price': json['price'],
        'isActive': json['isActive'],
        'type': (0, _1.NftTypeFromJSON)(json['type']),
        'sortPriority': !(0, runtime_1.exists)(json, 'sortPriority') ? undefined : json['sortPriority'],
    };
}
exports.NftSaleConfigFromJSONTyped = NftSaleConfigFromJSONTyped;
function NftSaleConfigToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'name': value.name,
        'description': value.description,
        'icon': value.icon,
        'image': value.image,
        'lineItems': (value.lineItems.map(_1.NftSaleConfigLineItemToJSON)),
        'minQuantity': value.minQuantity,
        'maxQuantity': value.maxQuantity,
        'price': value.price,
        'isActive': value.isActive,
        'type': (0, _1.NftTypeToJSON)(value.type),
        'sortPriority': value.sortPriority,
    };
}
exports.NftSaleConfigToJSON = NftSaleConfigToJSON;
